export const SUBSCRIPTION_LIST_REQUEST = "SUBSCRIPTION_LIST_REQUEST";
export const SUBSCRIPTION_SAVE_REQUEST = "SUBSCRIPTION_SAVE_REQUEST";
export const SUBSCRIPTION_GET_REQUEST = "SUBSCRIPTION_GET_REQUEST";
export const SUBSCRIPTION_ACTIVE_DEACTIVE_REQUEST = "SUBSCRIPTION_ACTIVE_DEACTIVE_REQUEST";
